/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_At_HomeInputs */

const en_shopping_at_home = /** @type {(inputs: Shopping_At_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already at home`)
};

const de_shopping_at_home = /** @type {(inputs: Shopping_At_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schon zu Hause`)
};

/**
* | output |
* | --- |
* | "Already at home" |
*
* @param {Shopping_At_HomeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_at_home = /** @type {((inputs?: Shopping_At_HomeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_At_HomeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_at_home(inputs)
	return en_shopping_at_home(inputs)
});